import BreadCrumb from "components/Common/BreadCrumb";
import CollapseFilter from "components/Common/CollapseFilter";
import CopyWrapper from "components/Common/CopyWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { LIST_USER_PLAN_STATUS } from "helpers/constans";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  getOptionImage,
} from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import { useSelector } from "react-redux";
import CountUp from "react-countup";
import NO_IMAGE_USER from "../../assets/images/no-user.png";
import NO_IMAGE_JOB from "../../assets/images/no-job-post.png";
import DropdownAsyncPlan from "components/Common/DropdownAsyncPlan";
import { getResumeViewLogs } from "store/resume-view-log/thunk";
import ModalPreview from "components/Common/ModalPreview";
import ModalMultiPreviewImage from "components/Common/ModalMultiPreviewImage";
import PlanForm from "pages/PlanManagement/PlanForm";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const ResumeViewLogList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    applicantEmailSns: withDefault(StringParam, ""),
    applicantEmail: withDefault(StringParam, ""),
    applicantFullname: withDefault(StringParam, ""),
    applicantNickname: withDefault(StringParam, ""),
    applicantPhoneNumber: withDefault(StringParam, ""),
    storeManagerEmail: withDefault(StringParam, ""),
    storeManagerName: withDefault(StringParam, ""),
    storeManagerPhoneNumber: withDefault(StringParam, ""),
    storeName: withDefault(StringParam, ""),
    jobTitle: withDefault(StringParam, ""),
    planIds: withDefault(StringParam, ""),
    isActive: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, "created_at"),
    // orderBy: withDefault(StringParam, "DESC"),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : moment().subtract(7, "days").toDate(),
    query?.endDate
      ? moment(query?.endDate || "", "Y-MM-DD").toDate()
      : moment().toDate(),
  ]);
  const [startDate, endDate] = dateSearch;

  const [planSearch, setPlanSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [applicantEmailSnsSearch, setApplicantEmailSnsSearch] =
    useState<string>(query?.applicantEmailSns || "");
  const [applicantEmailSearch, setApplicantEmailSearch] = useState<string>(
    query?.applicantEmail || ""
  );
  const [applicantFullnameSearch, setApplicantFullnameSearch] =
    useState<string>(query?.applicantFullname || "");
  const [applicantNicknameSearch, setApplicantNicknameSearch] =
    useState<string>(query?.applicantNickname || "");
  const [applicantPhoneNumberSearch, setApplicantPhoneNumberSearch] =
    useState<string>(query?.applicantPhoneNumber || "");
  const [storeManagerEmailSearch, setStoreManagerEmailSearch] =
    useState<string>(query?.storeManagerEmail || "");
  const [storeManagerNameSearch, setStoreManagerNameSearch] = useState<string>(
    query?.storeManagerName || ""
  );
  const [storeManagerPhoneNumberSearch, setStoreManagerPhoneNumberSearch] =
    useState<string>(query?.storeManagerPhoneNumber || "");
  const [storeNameSearch, setStoreNameSearch] = useState<string>(
    query?.storeName || ""
  );
  const [jobTitle, setJobTitleSearch] = useState<string>(query?.jobTitle || "");

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_USER_PLAN_STATUS?.find((item) => item?.value === query?.isActive)
      ?.value || ""
  );

  const [previewQRCode, setPreviewQRCode] = useState<any>(null);
  const [isOpenEditPlanDetail, setIsOpenEditPlanDetail] = useState<any>(false);
  const [itemEditPlanDetail, setItemEditPlanDetail] = useState<any>(null);
  const [listCheckedUsers, setListCheckedUsers] = useState<any>(null);
  const [linkImage, setLinkImage] = useState<any>(null);

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.ResumeViewLog;

  const ResumeViewLogProperties = createSelector(
    selectLayoutState,
    (state) => ({
      resumeViewLogs: state?.resumeViewLogs,
      isResumeViewLogLoading: state?.isResumeViewLogLoading,
      isResumeViewLogSuccess: state?.isResumeViewLogSuccess,
      error: state?.error,
    })
  );

  // Inside your component
  const { resumeViewLogs, isResumeViewLogLoading } = useSelector(
    ResumeViewLogProperties
  );

  function loadTableData() {
    dispatch(getResumeViewLogs(query));
  }

  const searchData = () => {
    const formatPlanData =
      planSearch?.value && planSearch?.value !== "all" ? planSearch?.value : "";

    setQuery({
      ...query,
      applicantEmail: applicantEmailSearch || "",
      applicantEmailSns: applicantEmailSnsSearch || "",
      applicantFullname: applicantFullnameSearch || "",
      applicantNickname: applicantNicknameSearch || "",
      applicantPhoneNumber: applicantPhoneNumberSearch || "",
      storeManagerEmail: storeManagerEmailSearch || "",
      storeManagerName: storeManagerNameSearch || "",
      storeManagerPhoneNumber: storeManagerPhoneNumberSearch || "",
      storeName: storeNameSearch || "",
      jobTitle: encodeURIComponent(jobTitle) || "",
      planIds: formatPlanData || "",
      isActive: statusSearch,
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        applicantEmail: "",
        applicantEmailSns: "",
        applicantFullname: "",
        applicantNickname: "",
        applicantPhoneNumber: "",
        storeManagerEmail: "",
        storeManagerName: "",
        storeManagerPhoneNumber: "",
        storeName: "",
        jobTitle: "",
        planIds: "",
        isActive: "",
        startDate: "",
        endDate: "",
        sortBy: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setApplicantNicknameSearch("");
    setApplicantFullnameSearch("");
    setApplicantEmailSearch("");
    setApplicantEmailSnsSearch("");
    setApplicantPhoneNumberSearch("");
    setStoreManagerNameSearch("");
    setStoreManagerEmailSearch("");
    setStoreManagerPhoneNumberSearch("");
    setStoreNameSearch("");
    setJobTitleSearch((_prev) => "");
    setPlanSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setDateSearch([moment().subtract(7, "days").toDate(), moment().toDate()]);
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 90,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ whiteSpace: "nowrap", width: "fit-content" }}>
              {resumeViewLogs?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Job Seeker"),
        accessor: "JobSeeker",
        filterable: false,
        sortable: false,
        thWidth: 250,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const user: any = cell?.row?.original?.applicant;
          const images = user?.profile?.imageUrls;
          return (
            <div
              style={{ width: "230px" }}
              className="d-flex align-items-center gap-2"
            >
              <div
                className="cursor-pointer overflow-hidden object-fit-cover"
                style={{
                  height: "45px",
                  width: "45px",
                  minWidth: "45px",
                }}
                onClick={() =>
                  setLinkImage(
                    images?.length > 1 ? { urls: images } : { url: images?.[0] }
                  )
                }
              >
                <img
                  className="overflow-hidden object-fit-cover rounded-circle"
                  src={images?.[0] || NO_IMAGE_USER}
                  alt={user?.profile?.nickname}
                  height={45}
                  width={45}
                  style={{
                    minWidth: "45px",
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = NO_IMAGE_USER;
                  }}
                />
              </div>
              {user?.profile ? (
                <div>
                  <div className="fw-semibold">
                    {user?.profile?.nickname || ""} -{" "}
                    <small className="fw-medium text-secondary">
                      {user?.profile?.phoneNumber || ""}
                    </small>
                  </div>
                  <small className="text-secondary">
                    {user?.profile?.fullname || ""} <br />
                    {user?.profile?.email || ""}
                  </small>
                  <br />
                </div>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Published at"),
        accessor: "applicant.visibleInRecruitmentAt",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "whitespace-nowrap text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value || "");
          const arrDatePublish = String(date || "").split(" ");

          return (
            <div className="text-end">
              <span>
                <span>{arrDatePublish?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">
                  {arrDatePublish?.[1] || "-"}
                </span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Recruiter"),
        accessor: "Recruiter",
        filterable: false,
        sortable: false,
        thWidth: 270,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const recruiter = cell?.row?.original?.recruiter;
          return (
            <div className="d-flex chat-log-px-0 align-items-center">
              <div
                style={{ width: "250px" }}
                className="d-flex align-items-center gap-2"
              >
                {/* <div
                  style={{
                    height: "45px",
                    width: "45px",
                    minWidth: "45px",
                    overflow: "hidden",
                    objectFit: "cover",
                  }}
                >
                  <img
                    src={recruiter?.store?.thumbnailUrl || NO_IMAGE_JOB}
                    alt={recruiter?.store?.name}
                    height={45}
                    width={45}
                    style={{
                      minWidth: "45px",
                      overflow: "hidden",
                      objectFit: "cover",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = NO_IMAGE_USER;
                    }}
                  />
                </div> */}
                {recruiter?.store ? (
                  <div>
                    <div className="fw-semibold">
                      {recruiter?.store?.managerName || ""} -{" "}
                      <small className="fw-medium text-secondary">
                        {recruiter?.store?.managerPhoneNumber || ""}
                      </small>
                    </div>
                    <small className="text-secondary">
                      {recruiter?.store?.managerEmail || ""}
                    </small>
                    <br />
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Store"),
        accessor: "Store",
        filterable: false,
        sortable: false,
        thWidth: 280,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const recruiter = cell?.row?.original?.recruiter;
          return (
            <div className="d-flex chat-log-px-0 align-items-center">
              <div
                style={{ width: "200px" }}
                className="d-flex align-items-center gap-2"
              >
                <div
                  className="cursor-pointer overflow-hidden object-fit-cover"
                  style={{
                    height: "55px",
                    width: "55px",
                    minWidth: "55px",
                  }}
                  onClick={() =>
                    setLinkImage({ url: recruiter?.store?.thumbnailUrl || "" })
                  }
                >
                  <img
                    className="overflow-hidden object-fit-cover"
                    src={recruiter?.store?.thumbnailUrl || NO_IMAGE_JOB}
                    alt={recruiter?.store?.name}
                    height={55}
                    width={55}
                    style={{
                      minWidth: "55px",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = NO_IMAGE_JOB;
                    }}
                  />
                </div>
                {recruiter?.store ? (
                  <div>
                    <div className="fw-semibold">
                      {recruiter?.store?.name || ""}
                    </div>
                    <small className="text-secondary">
                      {recruiter?.store?.address?.shortAddress || ""}
                    </small>
                    <br />
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Plan Name"),
        accessor: "planPurchase",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const item = cell?.value;
          const planName = item?.plan?.info?.name;
          return planName ? (
            <div
              className="cursor-pointer text-primary"
              style={{ minWidth: 180 }}
            >
              <span
                className="flex"
                onClick={() => {
                  setItemEditPlanDetail(item?.plan);
                  setIsOpenEditPlanDetail(true);
                }}
              >
                {`${planName}`}
              </span>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Job Post Related"),
        accessor: "planPurchase.jobPost",
        filterable: false,
        sortable: false,
        thWidth: 280,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.value as any;
          const jobImages = item?.jobAttachment;
          const jobImage = jobImages?.[0]?.url || "";
          const formatPreviewImages =
            item?.jobAttachment?.length > 0 &&
            item?.jobAttachment?.map((image: any) => image?.url);

          return item ? (
            <div className="d-flex align-items-center gap-2">
              <div
                className="cursor-pointer overflow-hidden object-fit-cover"
                style={{
                  height: "55px",
                  width: "55px",
                  minWidth: "55px",
                }}
                onClick={() =>
                  setLinkImage(
                    jobImages?.length > 1
                      ? { urls: formatPreviewImages }
                      : { url: jobImage }
                  )
                }
              >
                <img
                  className="overflow-hidden object-fit-cover"
                  src={jobImage || NO_IMAGE_JOB}
                  alt={item?.title}
                  height={55}
                  width={55}
                  style={{
                    minWidth: "55px",
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = NO_IMAGE_JOB;
                  }}
                />
              </div>
              <div>
                <CopyWrapper contentCopy={item?.title}>
                  {`${item?.title}`}
                </CopyWrapper>
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },

      {
        Header: t("Viewed at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "80px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    [i18n?.language, resumeViewLogs?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onClosePlanDetailClick = () => {
    setIsOpenEditPlanDetail(false);
    setItemEditPlanDetail(null);
  };

  const handleSelectAsyncUsers = (event: any) => {
    setListCheckedUsers(event);
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Resume View Log")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Resume View Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={resumeViewLogs?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col md={12}>
                        <div
                          className="d-flex flex-column pb-3 pt-2 px-3 position-relative"
                          style={{
                            border: "1px dashed var(--vz-primary)",
                            borderRadius: "4px",
                          }}
                        >
                          <span
                            className="text-primary position-absolute fs-13 px-1"
                            style={{
                              backgroundColor: "var(--vz-secondary-bg)",
                              top: "0px",
                              transform: "translateY(-50%)",
                            }}
                          >
                            {t("Job Seeker")}
                          </span>

                          <Row className="g-4 align-items-center mt-0 mt-md-2">
                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!applicantNicknameSearch}
                                label={`${t("Nick Name")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Nick Name")}...`}
                                  value={applicantNicknameSearch}
                                  onChange={(e) =>
                                    setApplicantNicknameSearch(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!applicantFullnameSearch}
                                label={`${t("Full Name")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Full Name")}...`}
                                  value={applicantFullnameSearch}
                                  onChange={(e) =>
                                    setApplicantFullnameSearch(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!applicantEmailSearch}
                                label={`${t("Email Profile")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Email Profile")}...`}
                                  value={applicantEmailSearch}
                                  onChange={(e) =>
                                    setApplicantEmailSearch(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!applicantPhoneNumberSearch}
                                label={`${t("Phone Number")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Phone Number")}...`}
                                  value={applicantPhoneNumberSearch}
                                  onChange={(e) =>
                                    setApplicantPhoneNumberSearch(
                                      e.target.value
                                    )
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col md={12}>
                        <div
                          className="d-flex flex-column pb-3 pt-2 px-3 position-relative"
                          style={{
                            border: "1px dashed var(--vz-primary)",
                            borderRadius: "4px",
                          }}
                        >
                          <span
                            className="text-primary position-absolute fs-13 px-1"
                            style={{
                              backgroundColor: "var(--vz-secondary-bg)",
                              top: "0px",
                              transform: "translateY(-50%)",
                            }}
                          >
                            {t("Recruiter")}
                          </span>

                          <Row className="g-4 align-items-center mt-0 mt-md-2">
                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!storeManagerNameSearch}
                                label={`${t("Full Name")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Full Name")}...`}
                                  value={storeManagerNameSearch}
                                  onChange={(e) =>
                                    setStoreManagerNameSearch(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!storeManagerEmailSearch}
                                label={`${t("Email")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Email")}...`}
                                  value={storeManagerEmailSearch}
                                  onChange={(e) =>
                                    setStoreManagerEmailSearch(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!storeManagerPhoneNumberSearch}
                                label={`${t("Phone Number")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Phone Number")}...`}
                                  value={storeManagerPhoneNumberSearch}
                                  onChange={(e) =>
                                    setStoreManagerPhoneNumberSearch(
                                      e.target.value
                                    )
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>

                            <Col
                              sm={12}
                              md={3}
                              xl={3}
                              xxl={3}
                              className="mt-3 mt-md-2"
                            >
                              <LabelWrapper
                                isShow={!!storeNameSearch}
                                label={`${t("Store Name")}`}
                              >
                                <Input
                                  type="text"
                                  className="form-control search"
                                  placeholder={`${t("Store Name")}...`}
                                  value={storeNameSearch}
                                  onChange={(e) =>
                                    setStoreNameSearch(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      searchData();
                                    }
                                  }}
                                />
                              </LabelWrapper>
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Job Title")}
                          isShow={!!jobTitle}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Job Title")}...`}
                            value={jobTitle}
                            onChange={(e) => setJobTitleSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Plan")} isShow={true}>
                          <DropdownAsyncPlan
                            name="plan"
                            placeholder={`${t("Plan")}...`}
                            listCheckedOption={planSearch}
                            onChangeSelect={(event: any) =>
                              setPlanSearch(event)
                            }
                            isAllOption={true}
                            hideSelectedOptions={true}
                            isMulti={false}
                            isClearable={false}
                            defaultParams={{
                              "planFeatures[]": "VIEW_RESUME",
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-resume-view-log-list"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        resumeViewLogs?.items?.length
                          ? resumeViewLogs?.items
                          : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={resumeViewLogs?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(resumeViewLogs?.pagination?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isResumeViewLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpenEditPlanDetail && (
          <PlanForm
            id={itemEditPlanDetail?.id}
            item={itemEditPlanDetail}
            setItemToEdit={setItemEditPlanDetail}
            setIsOpen={setIsOpenEditPlanDetail}
            triggerRefresh={onClosePlanDetailClick}
          />
        )}

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreviewImage
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default ResumeViewLogList;
